import React, { useEffect, useState } from "react";
import Avatar from "../shared/avatar.component";
import { AlertCancelIcon, CancelDeleteChatIcon, CancelIcon, CancelSecondaryIcon, CancelSubscriptionIcon, DropDownBlueIcon, GreenCheckMarkIcon, TickIcon, TicketAssignedHowerIcon, TicketAssignedIcon, TicketCloseIcon, TicketFollowingIcon, TicketHighIcon, TicketLowIcon, TicketMediumIcon, TicketOpenIcon, TicketUnassignedIcon, TicketingDropdownIcon, TicketingStatusClosedIcon, TicketingStatusFollowingIcon, TicketingStatusOpenIcon, ToasterCancelIcon, UserAssaignIcon } from "../../icon";
import { ListItemText, MenuItem, Popover, Select, Tooltip } from "@mui/material";
import { ChanneTicketingPriority, ChanneTicketingStatus } from "../../models/channels/channels.model";
import { ChannelUserModel } from "../../models/users.model";
import { ChannelUserService } from "../../services/ChannelUserService";
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"
import { UtilityService } from "../../services/UtilityService";
import { ChannelConversationStatus } from "../../models/conversations";
import { isatty } from "tty";
import CustomTooltip from "./CustomTooltip ";


interface IProps {
    ParticipantId: string;
    AssignedTo: string;
    Status: number;
    Priority: number;
    TicketHandlers: string[];
    CloseTicketingPopover: () => void;
}


const TicketingComponent: React.FC<IProps> = (Props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const ChannelUsers: ChannelUserModel[] = useSelector(selector.ChannelUsers)
    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();

    const [isAssigneeMenuOpen, setIsAssigneeMenuOpen] = useState<boolean>(false)
    const [isStatusMenuOpen, setIsStatusMenuOpen] = useState<boolean>(false)
    const [isPriorityMenuOpen, setIsPriorityMenuOpen] = useState<boolean>(false)
    const [assignee, setAssignee] = useState<string>(Props.AssignedTo);
    const [status, setStatus] = useState<number>(Props.Status);
    const [priority, setPriority] = useState<number>(Props.Priority);
    const [assignAnchor, SetAssignAnchor] = useState(null);
    const [statusAnchor, SetStatusAnchor] = useState(null);
    const [priorityAnchor, SetPriorityAnchor] = useState(null);

    useEffect(() => {
        setAssignee(Props.AssignedTo)
    }, [Props.AssignedTo])

    useEffect(() => {
        setPriority(Props.Priority)
    }, [Props.Priority])

    useEffect(() => {
        setStatus(Props.Status)
    }, [Props.Status])

    const handleAssigneeMenu = () => {
        setIsAssigneeMenuOpen(!isAssigneeMenuOpen)

    }
    const handleStatusMenu = () => {
        setIsStatusMenuOpen(!isStatusMenuOpen)
    }
    const handlePriorityMenu = () => {
        setIsPriorityMenuOpen(!isPriorityMenuOpen)
    }

    const handleAssignee = (value) => {
        if (value != assignee) {
            setAssignee(value)
            ChannelUserService.assignTicket(CurrentUser.OrganizationID, Props.ParticipantId, { assigned_to: value === "You" ? CurrentUser.ID : ChannelUsers.find(x => x.FullName === value)?.ID || "UNASSIGNED", admin: CurrentUser.ID }).then(() => {
            }).catch(() => { })
            handleAssigneeMenu();
        }
    }

    const handleStatus = (value) => {
        if (value != status) {
            setStatus(value)
            ChannelUserService.updateTicketStatus(CurrentUser.OrganizationID, Props.ParticipantId, { status: value, admin: CurrentUser.ID }).then(() => {
            }).catch(() => { })
            handleStatusMenu();
        }
    }

    const handlePriority = (value) => {
        if (!isNaN(value) && value != priority) {
            setPriority(value)
            ChannelUserService.updateTicketPriority(CurrentUser.OrganizationID, Props.ParticipantId, { priority: value, admin: CurrentUser.ID }).then(() => {
            }).catch(() => { })
        }
        handlePriorityMenu();
    }

    return (
        <div className="w-p-100 h-p-100 d-flex align-center">
            <div className={` ${IsMobileDevice ? "min-w-5" : "min-w-6"} max-w-6 d-flex justify-center`}>
                <Tooltip title={priority === ChanneTicketingPriority.High ? "High priority" : priority === ChanneTicketingPriority.Medium ? "Medium priority" : "Low priority"} placement="top" classes={{ tooltip: 'bg-color-secondary color-primary-accent h5-medium box-shadow-live-chat-pop-up' }}>
                    {priority === ChanneTicketingPriority.High ?
                        <TicketHighIcon onClick={(e) => { SetPriorityAnchor(e.currentTarget); handlePriorityMenu(); }} className="my-auto c-pointer" />
                        : priority === ChanneTicketingPriority.Low ?
                            <TicketLowIcon onClick={(e) => { SetPriorityAnchor(e.currentTarget); handlePriorityMenu(); }} className="my-auto c-pointer" />
                            :
                            <TicketMediumIcon onClick={(e) => { SetPriorityAnchor(e.currentTarget); handlePriorityMenu(); }} className="my-auto c-pointer" />
                    }
                </Tooltip>
                {
                    isPriorityMenuOpen &&
                    <Popover
                        open={isPriorityMenuOpen}
                        anchorEl={priorityAnchor}
                        onClose={handlePriority}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        classes={{ paper: `max-h-44 br-2` }}
                    >
                        {
                            [{ Name: "Low", Value: 1 }, { Name: "Medium", Value: 2 }, { Name: "High", Value: 3 }].map((x) => (
                                <MenuItem key={x.Name} onClick={() => { handlePriority(x.Value) }}>
                                    <div className="d-flex align-center h5-medium justify-center min-h-3">
                                        {x.Name === "High" ?
                                            <TicketHighIcon className="mr-1" />
                                            : x.Name === "Low" ?
                                                <TicketLowIcon className="mr-1" />
                                                :
                                                x.Name === "Medium" &&
                                                <TicketMediumIcon className="mr-1" />}
                                        <span>{x.Name}</span>
                                        {priority === x.Value && <span><GreenCheckMarkIcon className="w-2 h-2 my-auto ml-1" /></span>}
                                    </div>
                                </MenuItem>
                            ))
                        }
                    </Popover>
                }
            </div>
            <div className={` ${IsMobileDevice ? "min-w-5" : "min-w-6"} max-w-6 d-flex justify-center`}>
                <Tooltip title={status === ChanneTicketingStatus.Open ? "Open" : "Close"} placement="top" classes={{ tooltip: 'bg-color-secondary color-primary-accent h5-medium box-shadow-live-chat-pop-up' }}>
                    {status === ChanneTicketingStatus.Open ?
                        <TicketingStatusOpenIcon onClick={(e) => { SetStatusAnchor(e.currentTarget); handleStatusMenu(); }} className="my-auto c-pointer" />
                        :
                        <TicketingStatusClosedIcon onClick={(e) => { SetStatusAnchor(e.currentTarget); handleStatusMenu(); }} className="my-auto c-pointer" />
                    }
                </Tooltip>
                {
                    isStatusMenuOpen &&
                    <Popover
                        open={isStatusMenuOpen}
                        anchorEl={statusAnchor}
                        onClose={handleStatusMenu}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        classes={{ paper: `max-h-44 br-2` }}
                    >
                        {
                            [{ Name: "Open", Value: ChanneTicketingStatus.Open }, { Name: "Close", Value: ChanneTicketingStatus.Closed }].map((x) => (
                                <MenuItem key={x.Name} value={x.Value} onClick={() => handleStatus(x.Value)}>
                                    <div className="d-flex justify-center align-center min-h-3 h5-medium">
                                        {x.Value === ChanneTicketingStatus.Open ?
                                            <TicketingStatusOpenIcon />
                                            :
                                            <TicketingStatusClosedIcon />
                                        }
                                        <span>{x.Name}</span>
                                        {status === x.Value && <span><GreenCheckMarkIcon className="w-2 h-2 my-auto ml-1" /></span>}
                                    </div>
                                </MenuItem>
                            ))
                        }
                    </Popover>
                }
            </div>
            <div className={` ${IsMobileDevice ? "min-w-5" : "min-w-6"} max-w-6 d-flex justify-center`}>
                <Tooltip placement="top" title={<div className="d-flex align-center pr-1">{assignee === "UnAssigned" ? <TicketUnassignedIcon className="mr-1" /> : <TicketAssignedHowerIcon className="mr-1" />}{assignee}</div>} classes={{ tooltip: 'bg-color-secondary color-primary-accent h5-medium box-shadow-live-chat-pop-up' }} >
                    {assignee === "UnAssigned" ?
                        <TicketUnassignedIcon onClick={(e) => { SetAssignAnchor(e.currentTarget); handleAssigneeMenu(); }} className="my-auto c-pointer" />
                        :
                        <TicketAssignedIcon onClick={(e) => { SetAssignAnchor(e.currentTarget); handleAssigneeMenu(); }} className="my-auto c-pointer" />
                    }
                </Tooltip>
                {
                    isAssigneeMenuOpen &&
                    <Popover
                        open={isAssigneeMenuOpen}
                        anchorEl={assignAnchor}
                        onClose={handleAssigneeMenu}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        classes={{ paper: `max-h-44 br-2` }}
                    >
                        {
                            [...Props.TicketHandlers, "UnAssigned"].map((name) => (
                                <MenuItem key={name} value={name} onClick={() => handleAssignee(name)}>
                                    <Avatar Name={name} Size={24} className="mr-1 my-auto" />
                                    <span className="h5-medium">
                                        {name}
                                    </span>
                                    {assignee === name && <span><GreenCheckMarkIcon className="w-2 h-2 mt-auto ml-1" /></span>}
                                </MenuItem>
                            ))
                        }
                    </Popover>
                }
            </div>
        </div >
    )
}



export default TicketingComponent;
